jQuery(function(){
  createSticky(jQuery('.section-header'));
});

function createSticky(sticky) {

    if (typeof sticky !== "undefined") {

        var pos = sticky.offset().top,
                win = jQuery(window);

        win.on("scroll", function() {
            if(win.scrollTop()==pos){
                sticky.removeClass("fixed");                
            }else{
            win.scrollTop() >= pos ? sticky.addClass("fixed") : sticky.removeClass("fixed");      
            }
        });         
    }
}

//:: START :: sections/main-product.liquid  ::
jQuery(document).ready(function(){
  if($(".product---gallery-v1").find(".product__gallery").length>0){
    $(".product---gallery-v1").find(".product__gallery").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: false,
        infinite: false,
        speed: 200,
        asNavFor: ".product__thumbnail",
        arrows: false,
        dots: false,
        draggable: false,
        focusOnSelect: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              draggable: true,
              arrows: true,
              prevArrow: '<button type="button" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M16.25 10.8333L6.595 10.8333L10.345 14.5833L9.16667 15.7617L3.405 9.99999L9.16667 4.23832L10.345 5.41666L6.595 9.16666L16.25 9.16666L16.25 10.8333Z" fill="currentColor"/></svg></button>',
              nextArrow: '<button type="button" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M3.75 10.8333L13.405 10.8333L9.655 14.5833L10.8333 15.7617L16.595 9.99999L10.8333 4.23832L9.655 5.41666L13.405 9.16666L3.75 9.16666L3.75 10.8333Z" fill="currentColor"/></svg></button>',
            }
          }
        ]
    });
  }
  if($(".product---gallery-v1").find(".product__thumbnail").length>0){
    $(".product---gallery-v1").find(".product__thumbnail").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: ".product__gallery",
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      speed: 200,
      infinite: false,
      arrows: true,
      prevArrow:
        '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.4641 7L4.46406 14L2.53906 12.1625L7.70156 7L2.53906 1.8375L4.46406 0L11.4641 7Z" fill="black"/></svg></button>',
      nextArrow:
        '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.4641 7L4.46406 14L2.53906 12.1625L7.70156 7L2.53906 1.8375L4.46406 0L11.4641 7Z" fill="black"/></svg></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 921,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 521,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
});
jQuery(document).on("click",".zoom-gallery",function(){
  jQuery('body').addClass("product-popup-open");
  jQuery('.product-media-modal').attr('open','');
});

jQuery(document).on("click",".product-media-modal__toggle",function(){
  jQuery('body').removeClass("product-popup-open");
});

jQuery(document).on("click",".hchoose-modal-button",function(){  
  jQuery('.hchoose-modal').addClass('js-modal-open');
});

jQuery(document).on('click',".hchoose-close",function(){
   jQuery('.hchoose-modal').removeClass('js-modal-open');
});

//:: END :: sections/main-product.liquid  ::

//:: START :: sections/usps-marquee.liquid  ::

$('.usps_marquee_slider').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1299,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

//:: END :: sections/usps-marquee.liquid  ::

//:: START :: sections/video-testimonials.liquid  ::

$(document).ready(function () {
var $swiperSelector = $('.swiper-container');
$swiperSelector.each(function(index) {
    var $this = $(this);
    $this.addClass('swiper-slider-' + index);
    var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 50;
    var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
    var loop = $this.data('loop') ? $this.data('loop') : false;
    var slidesDesktop = $this.data('slides-desktop') ? $this.data('slides-desktop') : 5;
    var slidesTablet = $this.data('slides-tablet') ? $this.data('slides-tablet') : 4;
    var slidesMobile = $this.data('slides-mobile') ? $this.data('slides-mobile') : 3;
    var slidesMobileinner = $this.data('slides-mobile-inner') ? $this.data('slides-mobile-inner') : 2;
    var spaceBetween = $this.data('space-between') ? $this.data('space-between'): 12;
    if(jQuery(window).width()<751){
      var lengthSize=Math.round(jQuery('.product-slidercount').val()/2);
      dragSize = (dragSize*lengthSize); 
    }else{
      dragSize = (dragSize*jQuery('.product-slidercount').val()); 
    }
    console.log("dragsize",dragSize);
  setTimeout(function(){
    var swiper = new Swiper('.swiper-slider-' + index, {
      direction: 'horizontal',
      loop: loop,
      freeMode: freeMode,
      spaceBetween: spaceBetween,
      breakpoints: {
        1920: {
          slidesPerView: slidesDesktop
        },
        1024: {
          slidesPerView: slidesTablet
        },
        767: {
           slidesPerView: slidesMobile
        },
        300: {
           slidesPerView: slidesMobileinner
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: dragSize
      }
   });
  },500);
});
});


//:: END :: sections/video-testimonials.liquid  ::

//:: START :: sections/powerful-ingradients.liquid  ::

$('.ingradients_slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 1099,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        centerMode: true
      }
    }
  ]
});

//:: END :: sections/powerful-ingradients.liquid  ::

//:: START :: sections/faqs.liquid  ::

document.addEventListener("DOMContentLoaded", function () {
  //const firstAccordionItemBody = firstAccordionItemHeader.nextElementSibling;

  // Open the first accordion item by default
  // firstAccordionItemHeader.classList.add("active");
  // firstAccordionItemBody.style.maxHeight =
  //   firstAccordionItemBody.scrollHeight + "px";

  const firstAccordionItemHeader = document.querySelector(".faqs_item_header");
  if (firstAccordionItemHeader) {
    const accordionItemHeaders = document.querySelectorAll(
      ".faqs_item_header"
    );
  
    accordionItemHeaders.forEach((accordionItemHeader) => {
      accordionItemHeader.addEventListener("click", (event) => {
        const currentlyActiveAccordionItemHeader = document.querySelector(
          ".faqs_item_header.active"
        );
        if (
          currentlyActiveAccordionItemHeader &&
          currentlyActiveAccordionItemHeader !== accordionItemHeader
        ) {
          currentlyActiveAccordionItemHeader.classList.toggle("active");
          currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
        }
        accordionItemHeader.classList.toggle("active");
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        if (accordionItemHeader.classList.contains("active")) {
          accordionItemBody.style.maxHeight =
            accordionItemBody.scrollHeight + "px";
        } else {
          accordionItemBody.style.maxHeight = 0;
        }
      });
    });
  }
});

//:: END :: sections/faqs.liquid  ::

//:: END :: sections/image-marquee.liquid  ::
$('.image_marquee_slider').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear',
  arrows:false,
  dots:false,
  responsive: [
    {
      breakpoint: 1240,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});
//:: END :: sections/image-marquee.liquid  ::

//:: START :: sections/comparison-chart.liquid  ::

$('.comparison_product_slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.75 8.00108C5.75 7.75108 5.875 7.50108 6 7.37608L10.125 3.25108C10.5 2.87608 11.125 2.87608 11.5 3.25108C11.875 3.62608 11.875 4.25108 11.5 4.62608L8.125 8.00108L11.5 11.3761C11.875 11.7511 11.875 12.3761 11.5 12.7511C11.125 13.1261 10.5 13.1261 10.125 12.7511L6.125 8.75108C5.875 8.50108 5.75 8.25108 5.75 8.00108Z" fill="white"/></svg></button>',
  nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.25 8.00108C10.25 7.75108 10.125 7.50108 10 7.37608L5.875 3.25108C5.5 2.87608 4.875 2.87608 4.5 3.25108C4.125 3.62608 4.125 4.25108 4.5 4.62608L7.875 8.00108L4.5 11.3761C4.125 11.7511 4.125 12.3761 4.5 12.7511C4.875 13.1261 5.5 13.1261 5.875 12.7511L9.875 8.75108C10.125 8.50108 10.25 8.25108 10.25 8.00108Z" fill="white"/></svg></button>',
});

//:: END :: sections/comparison-chart.liquid  ::

// special usps
$(document).ready(function () {
  setInterval(function(){
    if($('.subsave-usps').length == 0){
      jQuery(".recharge-subscription-widget .rc-selling-plans").append('<ul class="subsave-usps"> <li>FREE delivery every 30 days</li> <li>Guaranteed delivery during sell-outs</li> <li>Pause, update frequency or cancel anytime</li> </ul>');
    }
  },1000);

  setInterval(function(){
    if($('.onetime-radio-cust').length == 0){
      $('.rc-radio.onetime-radio .rc-radio__label').addClass('onetime-radio-cust');
      var onetimeRadio = jQuery(".rc-radio.onetime-radio .rc-radio__label").html();
      if (typeof onetimeRadio === "undefined") {
      }
      else{
        console.log("--->", onetimeRadio)
        var ontimeRadioArr = onetimeRadio.split(' ');
        console.log("--->", ontimeRadioArr)
        jQuery(".rc-radio.onetime-radio .rc-radio__label").html(ontimeRadioArr[0] +' '+ontimeRadioArr[1] + '<span>'+ontimeRadioArr[2]+'</span>');
      }
    }
  },1000);
});


jQuery(document).ready(function () {
  jQuery(document).on("click", ".product_variant_list", function () {
    var selVal = $(this).attr("data-vid");
    var selValAva = $(this).attr("data-available");
    var vPrice = $(this).attr("data-price");
    var vCprice = $(this).attr("data-cprice");
    var vSave = $(this).attr("data-save");

    if(vCprice){
      $('.price__sale .price-item--regular').show();
      $('.price__sale .price-item--regular').html(vCprice);
      $('.main_product_saveprice').html(vSave);
      $('.main_product_saveprice').show();
    }
    else{
      $('.price__sale .price-item--regular').hide();
      $('.main_product_saveprice').hide();
    }
    $('.price__sale .price-item--sale').html(vPrice);
    
    
    $('.product_variant_label').removeClass('active');
    $(this).find('.product_variant_label').addClass('active');
    $('input[name="id"]').val(selVal);
    if(selValAva == 'true'){
      $('.product-form__submit').attr("disabled", false);
      $('.product-form__submit .btn-atc_text svg').show();
      $('.product-form__submit .btn-atc_text span').html('Add to Cart');
    }
    else{
      $('.product-form__submit').attr("disabled", true);
      $('.product-form__submit .btn-atc_text svg').hide();
      $('.product-form__submit .btn-atc_text span').html('sold out');
    }
  });
});